import { Box, Typography, TextField, InputAdornment } from '@mui/material';
import { COLORS } from '../utils/constants';

/**
 * Simple weight input (number only)
 * Supports compact mode for inline display
 */
export default function WeightSelector({ value, onChange, compact = false }) {
  const handleInputChange = (event) => {
    const val = event.target.value;

    // Allow empty string for user to clear and type fresh value
    if (val === '') {
      onChange('');
      return;
    }

    const numVal = Number(val);
    if (numVal >= 0.1 && numVal <= 1000) {
      onChange(numVal);
    }
  };

  const handleBlur = () => {
    // Set minimum value only on blur if empty
    if (value === '' || value < 0.1) {
      onChange(0.1);
    }
  };

  return (
    <Box>
      {!compact && (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: COLORS.textPrimary,
            mb: 1.5,
            fontSize: '0.875rem',
            letterSpacing: '0.5px',
          }}
        >
          Package weight
        </Typography>
      )}
      <TextField
        size="small"
        fullWidth
        type="number"
        placeholder="Weight"
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        inputProps={{
          min: 0.1,
          max: 1000,
          step: 0.1,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Typography
                sx={{
                  color: COLORS.textSecondary,
                  fontWeight: 600,
                  fontSize: compact ? '0.8rem' : '0.875rem',
                }}
              >
                kg
              </Typography>
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 1.5,
            backgroundColor: COLORS.white,
            fontSize: compact ? '0.8rem' : '0.875rem',
            '& fieldset': {
              borderColor: COLORS.border,
              borderWidth: 1.5,
            },
            '&:hover fieldset': {
              borderColor: COLORS.primary,
            },
            '&.Mui-focused fieldset': {
              borderColor: COLORS.primary,
              borderWidth: 2,
            },
          },
          '& input': {
            fontWeight: 600,
            color: COLORS.textPrimary,
            padding: compact ? '6px 10px' : '8px 10px',
            height: compact ? '24px' : '28px',
          },
        }}
      />
    </Box>
  );
}
